import React from 'react'
import Title from './Title'
import dp from "../assets/dp.jpg"

const About = () => {
    const stack =[
        {
            id:1,
            title:"Html"
        },
        {
            id:2,
            title:"Css"
        },
        {
            id:3,
            title:"Javascript"
        },
        {
            id:4,
            title:"ReactJs"
        },
        {
            id:5,
            title:"NodeJs"
        },
        {
            id:6,
            title:"Java"
        },
        {
            id:7,
            title:"Spring Boot"
        },
        {
            id:8,
            title:"Cassandra"
        },
        {
            id:9,
            title:"ElasticSearch"
        },
        {
            id:10,
            title:"Kafka"
        },
        {
            id:11,
            title:"Redis"
        },
        {
            id:12,
            title:"Data Structure and Algorithms"
        },
        {
            id:13,
            title:"TestNG"
        },
        {
            id:14,
            title:"JUnit"
        },
        {
            id:15,
            title:"Playwright"
        }
    ]

    return <section className="about-page" id="about">
    <Title title="about me"/>
        <div className="section-center about-center">
            <div className="dp-img-box">
                <img src={dp} alt="" className="about-img"/>
            </div>
            <article className="about-text">
                <p>Dedicated Software Developer with 3 years of experience, blending technical expertise, innovation, and a passion for continuous learning to achieve excellence. Adept collaborator in cross-functional teams, driving project goals and elevating code quality.</p>
                <div className="about-stack">
                    {stack.map(item => {
                        return <span key={item.id}>{item.title}</span>
                    })}
                </div>
            </article>
        </div>
    </section>
}

export default About
